<app-header></app-header>
<div class="tutto relative mb-[30vh]">

  <div (click)="showPop = false"
    class="absolute left-[50%] right-[50%]  bg-black bg-opacity-50  z-[9999999] items-center justify-center flex"
    *ngIf="showPop">

    <div class="pop h-fit   " *ngIf="showPop" [ngClass]="{'pop-non-opaco': showPop}" (click)="$event.stopPropagation()">
      <div class="tit mt-5 ">
        <h3>Conferma eliminazione coupon</h3>
      </div>
      <div class="frase mt-5 px-[52px] ">
        <p>Sei sicuro di volere eliminare il coupon? Questa azione sarà irreversibile</p>
      </div>
      <div class=" flex mb-5 mt-10 px-5" index="index">

        <div class=" mr-[5px]  w-[200px]  cursor-pointer  ">

          <stdout-button class="btn-bianco" (click)="annulla()" size="large" color="white">
            <h2>{{"annulla"|transloco}}</h2>
          </stdout-button>
        </div>
        <div class=" ml-[5px]  w-[200px]  cursor-pointer  ">

          <stdout-button class="btn-blu" (click)="deleteOperator()" size="large" color="white">
            <h2>Elimina coupon</h2>
          </stdout-button>
        </div>

      </div>
    </div>

  </div>




  <div class=" tutto-2 " [class.opacity-50]="showPop==true">
    <div class=" mt-10 px-10">
      <!-- <div class=" ">
        <div class="flex  items-stretch " *ngIf="!isPhone">
          <stdout-icon-button class="lente" style="margin: 2px 10px 0px 0px;" size="small" background="secondary"
            color="white" borderColor="secondary" [icon]="faMagnifyingGlass">
          </stdout-icon-button>
          <div class="w-[300px] h-[44px]">
            <stdout-text-input class="search-bar" placeholder="Nome collaboratore..." [(ngModel)]="search"
              (keyup)="applyFilter()"></stdout-text-input>
          </div>
        </div>
      </div> -->
      <div class="w-full">
        <div class="flex justify-end align-baseline   items-center ">
          <div class="mr-[15px] ">
            <h1>Aggiungi coupon</h1>
          </div>
          <div class=" cursor-pointer">
            <stdout-icon-button class="lente" (click)="newCoupon.validoAl = minDate;showModalAddCoupon = true" [icon]="faPlus"></stdout-icon-button>

          </div>
        </div>
      </div>
    </div>





    <div class=" ml-10 mr-10 mt-10 prt2 hi font-tab smart-tab">




      <stdout2-table class="op font-tab" [data]="operatori">
        <span stdoutTableColumn label="CODICE" property="Nome">
          <ng-template #dataTableCell let-item="item" let-index="index">
            <div>
              {{item.stripeCouponId}}
            </div>
          </ng-template>
        </span>
        <span stdoutTableColumn label="Valore" property="Nome">
          <ng-template #dataTableCell let-item="item" let-index="index">
            <div>
              {{item.tipoSconto == 3 ? item.numSettimane:item.valore}}{{item.tipoSconto == 1 ? '%' : (item.tipoSconto == 3 ? (item.numSettimane == 1 ? ' Settimana':' Settimane') :'€')}}
            </div>
          </ng-template>
        </span>
        <span stdoutTableColumn label="Scadenza" property="Scadenza">
          <ng-template #dataTableCell let-item="item" let-index="index">
            <div>
              {{item.validoAl}}
            </div>
          </ng-template>
        </span>
        <!-- <span stdoutTableColumn label="Utilizzi" property="Nome">
          <ng-template #dataTableCell let-item="item" let-index="index">
            <div>
              {{item.maxUtilizzi != null ? item.maxUtilizzi : 'Illimitati'}}
            </div>
          </ng-template>
        </span>
        <span stdoutTableColumn label="ATTIVO" property="Nome">
          <ng-template #dataTableCell let-item="item" let-index="index">
            <div>
              {{item.attivo ? 'Si' : 'No'}}
            </div>
          </ng-template>
        </span> -->


        <span stdoutTableColumn label="ELIMINA" property="icona">
          <ng-template #dataTableCell let-item="item" let-index="index">
            <div class="flex items-center justify-center gap-x-4">
              <div
                *ngIf="showBtn||  (item.id !== idToModify && (!showInput || showInput2) )  ||  idToModify!==index && !showBtn2 && (operatori.length -1) !== index ">


                <stdout-icon-button (click)="elimina(item.id)" class="tab-icon  cursor-pointer" color="primary"
                  borderColor="primary" background="white" size="small" [icon]="faTrashCan"></stdout-icon-button>

              </div>
              <div *ngIf="  showInput && (operatori.length -1 ) === index">
                <stdout-icon-button class="tab-icon cursor-pointer" (click)="createOperator()" color="primary"
                  borderColor="primary" background="white" size="small" [icon]="faCheck"></stdout-icon-button>
              </div>

              <div *ngIf="item.id === idToModify  && (operatori.length ) !== index ">

                <stdout-icon-button (click)="modifyOperator(index)" class="tab-icon  cursor-pointer" color="primary"
                  borderColor="primary" background="white" size="small" [icon]="faCheck"></stdout-icon-button>

              </div>
            </div>


          </ng-template>
        </span>



      </stdout2-table>
    </div>





    <div class="mt-10 flex justify-center" *ngIf="operatori.length>0">
      <stdout-pagination [current]="page" [total]="totalPages" (goTo)="getPage($event)" (next)=" goNext($event)"
        (previous)="goBack($event)"></stdout-pagination>
    </div>
  </div>

</div>


<div *ngIf="showModalAddCoupon"
  class="fixed z-[9999] flex items-center place-content-center top-0 left-0 w-screen h-screen bg-black bg-opacity-30">
  <stdout-card class="bg-white rounded-xl overflow-hidden">
    <stdout-card-header>
      <div class="flex">
        <div>Aggiungi coupon</div>
        <div class="ml-auto" (click)="showModalAddCoupon = false">X</div>
      </div>
    </stdout-card-header>
    <stdout-card-content>
      <stdout-text-input *ngIf="newCoupon.tipoSconto !== 3" type="number" class="search-bar" placeholder="Valore"
        [(ngModel)]="newCoupon.valore"></stdout-text-input>
      <br>
      <stdout-text-input *ngIf="newCoupon.tipoSconto == 3" type="text" class="search-bar" placeholder="Codice personalizzato"
        [(ngModel)]="newCoupon.customCode"></stdout-text-input>
      <br>
      <div>
        <input [min]="minDate" [(ngModel)]="newCoupon.validoAl" class="border w-full text-[#0B0B0B] placeholder:text-[#6B7280] outline-none focus-visible:outline-none rounded-lg shadow-input text-sm px-3 py-2 hover:bg-opacity-5 focus:bg-opacity-5 disabled:border-[#BEC5C5] disabled:placeholder:text-[#BEC5C5] disabled:hover:bg-transparent border-[#6B7280] hover:border-[#47AD9F] hover:bg-[#47AD9F] focus:bg-[#47AD9F] focus:border-[#47AD9F] ng-untouched ng-pristine ng-valid" type="date">
     </div> <br>
      <!-- <stdout-text-input class="search-bar" placeholder="Utilizzi"
        [(ngModel)]="newCoupon.maxUtilizzi"></stdout-text-input>
      <br> -->
      <!-- <stdout-select class="fix-select" [placeholder]="'Attivo'" id="select1" type="text" [clearable]="false"
        [data]="[{value:true,key:'SI'},{value:false,key:'NO'}]" (onValueChange)="onAttivoChange($event)"
        #selectElement>
      </stdout-select>
      <br> -->
      
      <stdout-select *ngIf="newCoupon.tipoSconto == 3" class="fix-select" [placeholder]="'Settimane di prova'" id="select1" type="text" [clearable]="false"
        [data]="[{value:1,key:'1 settimana'},{value:2,key:'2 settimane'},{value:3,key:'3 settimana'},{value:4,key:'4 settimane'}]" (onValueChange)="onWeekChange($event)"
         #selectElement>
      </stdout-select>
      <br>
      <stdout-select class="fix-select" [placeholder]="'Tipo sconto'" id="select1" type="text" [clearable]="false"
        [data]="[{value:1,key:'Percentuale'},{value:2,key:'Fisso'},{value:3,key:'Prova gratuita'}]" (onValueChange)="onTypeChange($event)"
         #selectElement>
      </stdout-select>
      <br>
      <br>
      <br>
      <stdout-button [ngClass]="{'opacity-30 pointer-events-none': ((!newCoupon.valore && newCoupon.tipoSconto !== 3) || (!newCoupon.numSettimane && newCoupon.tipoSconto == 3)) || !newCoupon.tipoSconto}" (click)="createOperator()" class="btn-bianco" size="large" color="white">
        <h2>Crea coupon</h2>
      </stdout-button>
    </stdout-card-content>
  </stdout-card>
</div>